module.exports = __webpack_public_path__ + "static/img/bg04.da853e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg04.png
// module id = z4aj
// module chunks = 2